// If you don't want to use TypeScript you can delete this file!
import React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"

import './index.scss'
import ApiLogo from "../../../components/images/logo.api"
import GoToInstall from "../../../components/widgets/goToInstall"
import { CodeBlock } from "../../../components/widgets/codeBlock"
import { catalogoScripts } from "../../../scripts/catalogo"
import SectionNavigate from "../../../components/widgets/sectionNavigate"

type DataProps = {
    site: {
        buildTime: string
    }
}

const ApiCfdiMinimo: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <Layout isApi={true} location={location}>
        <SEO title="FiscalPOP para eCommerce" />
        <div id='ApiDocs' className="_DOCS withSide">
            <div className="content">
                <h2>Buscar Impuestos</h2>
                <p>
                De la respuesta de impuestos hay que extraer la información necesitada para usar en cada concepto.
                </p>
                <pre>
                    <code>
                        <b>GET:</b> https://api.fiscalpop.com/api/v1/sat/impuestos/<b><span className="error">:authToken</span></b>
                    </code>
                </pre>
                <h3>
                    Campos de la Respuesta
                </h3>
                <ul className="request">
                    <li>
                        <p>
                            <b>tipo: </b> Hay dos tipos de impuesto, FIJO como IVA 16% o Rango, como IVA de 10.66667% para IVA retenido en nómina.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>min: </b> Valor mínimo del rango posible, <code>null</code> si es tipo FIJO.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>max: </b> Valor máximo del rango posible, en caso de ser un impuesto FIJO será el valor del impuesto.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>impuesto: </b> IVA, IEPS, ISR.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>factor: </b> Tasa | Cuota, el factor de tasa es porcentual, <b>el valor de Cuota es valor monetario absoluto por cantidad del concepto</b>.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>traslado: </b> True si puede usarse como un impuesto trasladado (normal), False si no puede usarse como traslado.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>retencion: </b> True si puede usarse como impuesto retenido, False si no puede usarse como rentención.
                        </p>
                    </li>
                </ul>
                <SectionNavigate next={`/api/catalogo/catalogo-relacion`} previous={`/api/catalogo/catalogo-claveunidad`}/>
            </div>

            <div className="side">
                <CodeBlock title="Catálogo Impuestos" requests={[]} response={catalogoScripts.impuestos.response} />
            </div>
        </div>
    </Layout>
)

export default ApiCfdiMinimo
